module.exports = {
      id: "icon_file_insurance-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "images/js_src_vue/page_listary_landing/sprite.d9b7df9a.svg#icon_file_insurance-usage",
      toString: function () {
        return this.url;
      }
    }